import { useQueryPartyInfo } from './queries';

export const useGetPartyInfo = ({
  searchText,
  pageIndex,
  pageSize,
  recipientType,
}) => {
  const { data, isLoading } = useQueryPartyInfo({
    searchText,
    pageIndex,
    pageSize,
    recipientType,
  });

  return {
    gridData: data?.gridData ?? [],
    paging: data?.paging ?? {},
    isLoading,
  };
};

export const useGetWalmartPartyInfo = () => {
  const { data, isLoading } = useQueryPartyInfo({
    searchText: '',
    pageIndex: 1,
    pageSize: 999,
    recipientType: 'Walmart',
  });

  return {
    gridData: data?.gridData ?? [],
    paging: data?.paging ?? {},
    isLoading,
  };
};
